const ENVIRONMENTS = [
  { label: "DEV", url: "https://dev.visual-alpha.com" },
  { label: "STAGING", url: "https://staging.visual-alpha.com" },
  { label: "PRODUCTION", url: "https://app.visual-alpha.com" },
  { label: "LOCAL", url: "http://localhost:3000" }
]

export default ENVIRONMENTS
